import { createSaveInProgressFormReducer } from 'platform/forms/save-in-progress/reducers';

import itf from '../../all-claims/reducers/itf';
import mvi from '../../shared/reducers/mvi';
import formConfig from '../config/form';

export default {
  form: createSaveInProgressFormReducer(formConfig),
  itf,
  mvi,
};
